import { useStopEditingOnUnmount } from '@/hooks'

export function StopEditingOnUnmount() {
  useStopEditingOnUnmount()
  return null
}
